import { useIconColors } from './use-icon-colors';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const BarChartIcon = ({
  size = 25
}) => {
  const colors = useIconColors();
  if (!colors) {
    return /*#__PURE__*/_jsx("div", {});
  }
  const {
    orange,
    purple,
    aqua,
    yellow
  } = colors;
  return /*#__PURE__*/_jsx("div", {
    children: /*#__PURE__*/_jsxs("svg", {
      width: size,
      height: size,
      viewBox: "0 0 80 80",
      children: [/*#__PURE__*/_jsx("rect", {
        fill: orange,
        x: "0",
        y: "0",
        width: "80",
        height: "14"
      }), /*#__PURE__*/_jsx("rect", {
        fill: aqua,
        x: "0",
        y: "20",
        width: "62",
        height: "14"
      }), /*#__PURE__*/_jsx("rect", {
        fill: purple,
        x: "0",
        y: "40",
        width: "49",
        height: "14"
      }), /*#__PURE__*/_jsx("rect", {
        fill: yellow,
        x: "0",
        y: "60",
        width: "30",
        height: "14"
      })]
    })
  });
};
export default BarChartIcon;